// Chatbot.jsx
import React, { useState } from "react";
import axios from "axios";

const Chatbot = () => {
  const [messages, setMessages] = useState([
    { from: "bot", text: "Hello! I am Agro Assistant. How can I help you today?" },
  ]);
  const [input, setInput] = useState("");

  const sendMessage = async () => {
    if (!input.trim()) return;
    
    const userMessage = { from: "user", text: input };
    setMessages(prev => [...prev, userMessage]);
    setInput("");

    try {
      const res = await axios.post("https://api.agromanch.com/api/ai/chatbot", { message: input });
      
      // Handle both success and error responses
      if (res.data.success === false) {
        const errorMessage = res.data.error || "Something went wrong. Please try again.";
        const botMessage = { from: "bot", text: errorMessage };
        setMessages(prev => [...prev, botMessage]);
      } else {
        const botMessage = { from: "bot", text: res.data.answer || res.data.reply || "I'm here to help with your farming questions!" };
        setMessages(prev => [...prev, botMessage]);
      }
    } catch (err) {
      console.error("Chatbot error:", err);
      const errorMsg = { from: "bot", text: "Unable to connect to the chatbot service. Please make sure the server is running." };
      setMessages(prev => [...prev, errorMsg]);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") sendMessage();
  };

  return (
    <div style={{ maxWidth: 400, margin: "20px auto", border: "1px solid #ccc", padding: 10, borderRadius: 10 }}>
      <div style={{ height: 400, overflowY: "auto", padding: 10 }}>
        {messages.map((msg, i) => (
          <div
            key={i}
            style={{
              textAlign: msg.from === "bot" ? "left" : "right",
              margin: "10px 0",
            }}
          >
            <span
              style={{
                display: "inline-block",
                padding: "8px 12px",
                borderRadius: 20,
                background: msg.from === "bot" ? "#eee" : "#4caf50",
                color: msg.from === "bot" ? "#000" : "#fff",
              }}
            >
              {msg.text}
            </span>
          </div>
        ))}
      </div>
      <div style={{ display: "flex", marginTop: 10 }}>
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Ask about crop, disease, or medicine..."
          style={{ flex: 1, padding: 8, borderRadius: 20, border: "1px solid #ccc" }}
        />
        <button
          onClick={sendMessage}
          style={{ marginLeft: 5, padding: "8px 16px", borderRadius: 20, background: "#4caf50", color: "#fff", border: "none" }}
        >
          Send
        </button>
      </div>
    </div>
  );
};

export default Chatbot;